import { Theme } from "@aws-amplify/ui-react";

import { extractThemeColorsFromDOM } from "../Theme/ThemeColors";

const themeColors = extractThemeColorsFromDOM();

export const theme: Theme = {
  name: "DaisyUI",
  tokens: {
    colors: {
      background: {
        primary: { value: themeColors.base300 },
        secondary: { value: themeColors.base200 },
      },
      font: {
        primary: { value: themeColors.primary },
        secondary: { value: themeColors.secondary },
      },
    },
    components: {
      authenticator: {
        modal: { backgroundColor: themeColors.base100 },
      },
      tabs: {
        item: {
          color: { value: themeColors.accent },
          _focus: { color: { value: themeColors.accentFocus } },
          _hover: { color: { value: themeColors.accentFocus } },
          _active: { color: { value: themeColors.accent } },
        },
      },
      button: {
        backgroundColor: { value: themeColors.infoContent },
        color: { value: themeColors.info },
      },
    },
  },
};
